import { UserRole } from '../types/user';

interface RolePermissions {
  canView: string[]; // List of allowed route prefixes or '*' for all
  canEdit: string[]; // List of allowed edit actions/routes or '*' for all
  deniedRoutes: string[]; // Explicitly denied routes
}

export const PERMISSIONS: Record<UserRole, RolePermissions> = {
  ADMIN: {
    canView: ['*'],
    canEdit: ['*'],
    deniedRoutes: [],
  },
  CONTRACTOR: {
    canView: ['*'],
    canEdit: ['*'], // Contractors generally have edit rights in their scope
    deniedRoutes: [],
  },
  USER: {
    canView: ['/user', '/plans', '/site-visit', '/my-plans', '/', '/project'],
    canEdit: [], // Read-only
    deniedRoutes: ['/admin', '/contractor'],
  },
};

export const hasPermission = (role: UserRole | null, path: string, type: 'view' | 'edit' = 'view'): boolean => {
  if (!role) return false;

  const permissions = PERMISSIONS[role];
  if (!permissions) return false;

  // Check explicit denials first
  if (permissions.deniedRoutes.some(denied => path.startsWith(denied))) {
    return false;
  }

  const allowed = type === 'view' ? permissions.canView : permissions.canEdit;

  if (allowed.includes('*')) return true;

  return allowed.some(allowedPath => path.startsWith(allowedPath));
};
